import {
  CREATE_WISHLIST,
  REQUEST_WISHLISTS,
  RECEIVE_WISHLISTS
} from 'constants/ActionTypes'

const wishListsReducer = (state = initialWishListState, action) => {
  switch (action.type) {
    case REQUEST_WISHLISTS:
      return Object.assign({}, state, {
        isFetchingWishLists: true,
        didInvalidateWishLists: false
      })
    case RECEIVE_WISHLISTS:
      return Object.assign({}, state, {
        isFetchingWishLists: false,
        didInvalidateWishLists: false,
        wishLists: action.wishLists,
        lastUpdatedWishList: action.receivedAt
      })
    case CREATE_WISHLIST:
      return Object.assign({}, state, {
        wishLists: [
          ...state.wishLists
        ]
      })
    default:
      return state
  }
}

const initialWishListState = {
  isFetchingWishLists: false,
  wishLists: [],
  lastUpdatedWishList: null
}

export default wishListsReducer
